var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"risk_tip_w"},[_c('div',{staticClass:"tip_title font_w_bold fz20"},[_vm._v("风险提示")]),_c('div',{staticClass:"desc_w c_1A1A1A fz12",domProps:{"innerHTML":_vm._s(_vm.projectRisk)}})])}
var staticRenderFns = []

export { render, staticRenderFns }